import './AdminControls.css'

function AdminControls({ item, onEdit, onDelete, onToggleVisibility, type = 'row' }) {
  const handleEdit = (e) => {
    e.stopPropagation()
    onEdit && onEdit(item)
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    onDelete && onDelete(item)
  }

  const handleToggleVisibility = (e) => {
    e.stopPropagation()
    onToggleVisibility && onToggleVisibility(item)
  }

  return (
    <div className="admin-controls">
      <button
        className="control-btn edit-btn"
        onClick={handleEdit}
        title="Edit"
      >
        ✏️
      </button>
      <button
        className={`control-btn visibility-btn ${item.is_visible ? 'active' : ''}`}
        onClick={handleToggleVisibility}
        title={item.is_visible ? 'Hide from players' : 'Show to players'}
      >
        {item.is_visible ? '👁️' : '👁️‍🗨️'}
      </button>
      <button
        className="control-btn delete-btn"
        onClick={handleDelete}
        title="Delete"
      >
        🗑️
      </button>
    </div>
  )
}

export default AdminControls
